import { SvgIcon, SvgIconProps } from '@mui/material';

/** Pane grid (nav). */
export const Dashboard = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M2 9.5H22M9 9.5V22M9 15.5H22"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
